export const NO_DETAILS_MESSAGE =
  'This publisher has not submitted the trader information required by the European Digital Services Act.';
